var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NavTabs',{attrs:{"customClass":"capitalize_title","tabs":_vm.tabs,"activeTab":_vm.newActiveTab,"containerCustomStyle":'padding: 0px; max-width: initial;'},on:{"sendData":_vm.updateData}})}
var staticRenderFns = []

export { render, staticRenderFns }